export let ResilienceMechanism = /*#__PURE__*/function (ResilienceMechanism) {
  ResilienceMechanism["INDEXEDDB"] = "indexeddb";
  ResilienceMechanism["MEMORY"] = "memory";
  return ResilienceMechanism;
}({});
export let NetworkStatusEnum = /*#__PURE__*/function (NetworkStatusEnum) {
  NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
  NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
  return NetworkStatusEnum;
}({});